import {createMultiStyleConfigHelpers} from '@chakra-ui/styled-system';

const helpers = createMultiStyleConfigHelpers(['root', 'markup']);

/**
 * @typedef {import('@chakra-ui/styled-system').PartsStyleInterpolation<{
 *  keys: ("root" | "markup")[]
 * }>} RichTextBlockStyles
 */
export const richTextBlockStyles = helpers.defineMultiStyleConfig({
  /**
   * @param {Object} args - Component arguments
   * @param {Contentful.RichTextBlock} args.component - RichTextBlock component data
   * @param {boolean} [args.isComplete] - Whether component has all fields
   * @param {boolean} [args.isFetching] - Whether additional data is being fetched
   *
   * @returns {RichTextBlockStyles} - Component styles
   */
  baseStyle: ({
    component: {alignment = 'left', animation, quote, image},
  }) => {
    return {
      root: {
        textAlign: alignment,
      },
      markup: {
      },
    };
  },
});
